import React, { useState } from 'react';

/**
 * Small list-cell thumbnail for a DB-backed photo (see services/resources.js
 * getPhotoUrl). There's no cheap way to know ahead of time whether a row has
 * a photo, so this always attempts the image and falls back to a placeholder
 * on 404. Pass `key={src}` from the caller if the same slot's src can change
 * (e.g. after upload) so the fallback state resets.
 */
export default function PhotoThumb({ src, onClick }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) return <span className="text-xs text-gray-400">—</span>;

  return (
    <img
      src={src}
      alt=""
      className={`h-9 w-9 rounded object-cover ${onClick ? 'cursor-pointer hover:opacity-80' : ''}`}
      onClick={onClick}
      onError={() => setFailed(true)}
    />
  );
}
